import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import $ from 'jquery';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel';
import '../scss/style.scss';




(function() {
      'use strict';

      // =====================
      // 0a. Homepage preloader — hide once page is ready + min show time
      // =====================


(function initPreloader() {
   var preloader = document.getElementById('fmfPreloader');

  if (sessionStorage.getItem('fmf_loaded')) {
    if (preloader && preloader.parentNode) {
      preloader.parentNode.removeChild(preloader);
    }
    document.body.classList.add('page-loaded');
    return;
  }

  if (!preloader) {
    document.body.classList.add('page-loaded');
    return;
  }




  // ── Ripple canvas setup ──
  var canvas = document.getElementById('fmfRippleCanvas');
  var ctx = canvas ? canvas.getContext('2d') : null;
  var rippleRAF = null;
  var rippleStart = null;

  function resizeCanvas() {
    if (!canvas) return;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }


  // ── Hide logic ──
  var MIN_DISPLAY_MS = 500;
  var startedAt = Date.now();
  var hidden = false;

  function hide() {
    if (hidden) return;
    hidden = true;
    sessionStorage.setItem('fmf_loaded', '1'); 

    var elapsed = Date.now() - startedAt;
    var wait = Math.max(0, MIN_DISPLAY_MS - elapsed);

    setTimeout(function () {
  preloader.classList.add('is-hidden');
  document.body.classList.add('page-loaded');

  setTimeout(function() {
    document.querySelectorAll('.animate-on-scroll').forEach(function(el) {
      el.classList.add('is-visible');
    });
  }, 400);










  
  setTimeout(function () {
    if (preloader && preloader.parentNode) {
      preloader.parentNode.removeChild(preloader);
    }
  }, 5500);
}, wait);
  }

  if (document.readyState === 'complete') {
    hide();
  } else {
    window.addEventListener('load', hide, { once: true });
    setTimeout(hide, 2000); // safety net
  }
})();
      // =====================
      // 0. Mobile nav toggle (hamburger)
      // =====================
      (function initMobileNav() {
        var toggle = document.getElementById('navToggle');
        var links = document.getElementById('navLinks');
        if (!toggle || !links) return;

        function closeNav() {
          links.classList.remove('is-open');
          document.body.classList.remove('nav-open');
          toggle.setAttribute('aria-expanded', 'false');
        }

        toggle.addEventListener('click', function() {
          var isOpen = links.classList.toggle('is-open');
          document.body.classList.toggle('nav-open', isOpen);
          toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });

        links.querySelectorAll('a').forEach(function(a) {
          a.addEventListener('click', closeNav);
        });

        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape') closeNav();
        });

        window.addEventListener('resize', function() {
          if (window.innerWidth > 991) closeNav();
        });
      })();

      // =====================
      // 0b. Mega Menu overlay & transitions
      // =====================
      (function initMegaMenu() {
        const aboutDropdown = document.querySelector('.dropdown-hover');
        const overlay = document.querySelector('.mega-menu-overlay');
        if (!aboutDropdown || !overlay) return;

        aboutDropdown.addEventListener('mouseenter', function() {
          overlay.style.opacity = '1';
          overlay.style.visibility = 'visible';
          document.body.classList.add('mega-menu-open');
        });

        aboutDropdown.addEventListener('mouseleave', function() {
          overlay.style.opacity = '0';
          overlay.style.visibility = 'hidden';
          document.body.classList.remove('mega-menu-open');
        });
        
        // Handle closing when menu items inside are clicked
        const menuLinks = aboutDropdown.querySelectorAll('.mega-menu a');
        menuLinks.forEach(link => {
          link.addEventListener('click', () => {
            overlay.style.opacity = '0';
            overlay.style.visibility = 'hidden';
            document.body.classList.remove('mega-menu-open');
          });
        });
      })();

      // =====================
      // 1. Intersection Observer for scroll animations
      // =====================
      const scrollElements = document.querySelectorAll('.animate-on-scroll');
      const scrollObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

      scrollElements.forEach(function(el) {
        scrollObserver.observe(el);
      });

      // =====================
      // 2. Counter animation for stats numbers
      // =====================
      var statsAnimated = false;
      var statsSection = document.querySelector('.stats-section');

      function animateCounters() {
        if (statsAnimated) return;
        statsAnimated = true;

        var counters = document.querySelectorAll('.stat-number[data-target]');
        counters.forEach(function(counter) {
          var target = parseInt(counter.getAttribute('data-target'));
          var prefix = counter.getAttribute('data-prefix') || '';
          var suffix = counter.getAttribute('data-suffix') || '';
          var mainSuffix = suffix; // was .replace('+', '')
          var duration = 2000;
          var start = 0;
          var startTime = null;

          function easeOutQuart(t) {
            return 1 - Math.pow(1 - t, 4);
          }

          function update(timestamp) {
            if (!startTime) startTime = timestamp;
            var elapsed = timestamp - startTime;
            var progress = Math.min(elapsed / duration, 1);
            var easedProgress = easeOutQuart(progress);
            var current = Math.floor(easedProgress * target);
            counter.innerHTML = prefix + current + mainSuffix ; //was  + '<span class="stat-suffix">+</span>';
            if (progress < 1) {
              requestAnimationFrame(update);
            } else {
              counter.innerHTML = prefix + target + mainSuffix ; //was  + '<span class="stat-suffix">+</span>';
            }
          }

          requestAnimationFrame(update);
        });
      }

      var statsObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            animateCounters();
          }
        });
      }, { threshold: 0.3 });

      if (statsSection) {
        statsObserver.observe(statsSection);
      }

      // =====================
      // 3. Quote rotation in dialogue section
      // =====================
      var quoteItems = document.querySelectorAll('.quote-text-item');
      var currentQuote = 0;

      if (quoteItems.length > 1) {
        setInterval(function() {
          quoteItems[currentQuote].classList.remove('active');
          currentQuote = (currentQuote + 1) % quoteItems.length;
          quoteItems[currentQuote].classList.add('active');
        }, 4000);
      }

      // =====================
      // 4. Ticker close button functionality
      // =====================
      var tickerClose = document.getElementById('tickerClose');
      var tickerBar = document.getElementById('tickerBar');

      if (tickerClose && tickerBar) {
        tickerClose.addEventListener('click', function() {
          tickerBar.classList.add('hidden');
          setTimeout(function() {
            tickerBar.style.display = 'none';
          }, 400);
        });
      }

    




// 4b. CTA arrow animation on hover in/out changes*
// ================================
document.querySelectorAll('.cta-btn').forEach(function(btn) {
  var arrow = btn.querySelector('.cta-arrow');
  if (!arrow) return;

  btn.addEventListener('mouseenter', function() {
    arrow.style.filter = 'brightness(0) invert(1)';
    arrow.style.animation = 'none';
    arrow.offsetHeight;
    arrow.style.animation = 'arrowSlide 0.6s ease-in-out 1 forwards';
  });

  btn.addEventListener('mouseleave', function() {
    arrow.style.filter = '';
    arrow.style.animation = 'none';
  arrow.offsetHeight;
  arrow.style.animation = 'arrowSlide 0.2s ease-in-out 1 reverse forwards';
  });
});

//==============================================









      // =====================
      // 5. Nav shadow on scroll
      // =====================
      var mainNav = document.getElementById('mainNav');
      var navToggle = mainNav ? mainNav.querySelector('.nav-toggle') : null;
      var navLinks = mainNav ? mainNav.querySelectorAll('.nav-links a') : [];

      function setNavMenu(open) {
        if (!mainNav || !navToggle) return;

        mainNav.classList.toggle('menu-open', open);
        document.body.classList.toggle('nav-menu-open', open);
        navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        navToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      }

      if (navToggle) {
        navToggle.addEventListener('click', function() {
          setNavMenu(!mainNav.classList.contains('menu-open'));
        });

        navLinks.forEach(function(link) {
          link.addEventListener('click', function() {
            setNavMenu(false);
          });
        });

        window.addEventListener('resize', function() {
          if (window.innerWidth >= 768) {
            setNavMenu(false);
          }
        });

        document.addEventListener('keydown', function(event) {
          if (event.key === 'Escape') {
            setNavMenu(false);
          }
        });
      }

      window.addEventListener('scroll', function() {
        if (mainNav) {
          if (window.scrollY > 10) {
            mainNav.classList.add('scrolled');
          } else {
            mainNav.classList.remove('scrolled');
          }
        }
      }, { passive: true });

      // =====================
      // 6. Strategy timeline/arrows/dots + scroll sync
      // =====================
      var timelineYears = document.querySelectorAll('.timeline-year');
      var strategyCardsContainer = document.getElementById('strategyCards');
      var strategyCards = strategyCardsContainer ? strategyCardsContainer.querySelectorAll('.strategy-card') : [];
      var strategyProgressFill = document.getElementById('strategyProgressFill');
      var strategyPrev = document.getElementById('strategyPrev');
      var strategyNext = document.getElementById('strategyNext');
      var strategyDots = document.querySelectorAll('.strategy-dot');
      var timelineActive = document.getElementById('timelineActive');
      var currentStrategyIndex = 0;
      var programmaticStrategyIndex = null;
      var strategyScrollTimer = null;

      // Use getBoundingClientRect so the scroll offset is correct
      // regardless of the container's offsetParent. The old calculation
      // (card.offsetLeft - container.offsetLeft) broke on index 1 when
      // the two had different positioned ancestors.
      function scrollToStrategyCard(index) {
        if (!strategyCardsContainer || !strategyCards[index]) return;
        currentStrategyIndex = index;
        programmaticStrategyIndex = index;
        var card = strategyCards[index];
        var containerRect = strategyCardsContainer.getBoundingClientRect();
        var cardRect = card.getBoundingClientRect();
        var delta = cardRect.left - containerRect.left;
        strategyCardsContainer.scrollTo({
          left: strategyCardsContainer.scrollLeft + delta,
          behavior: 'smooth'
        });
        updateStrategyTimeline(index);
        updateStrategyProgress(index);
        updateStrategyDots(index);
        updateStrategyArrows(index);
      }

      function updateStrategyTimeline(index) {
        timelineYears.forEach(function(y, i) {
          y.classList.toggle('active', i === index);
        });
        if (timelineActive && strategyCards.length > 0) {
          var segmentWidth = 100 / strategyCards.length;
          timelineActive.style.left = (index * segmentWidth) + '%';
          timelineActive.style.width = segmentWidth + '%';
        }
      }

      function updateStrategyProgress(index) {
        if (strategyProgressFill && strategyCards.length > 0) {
          var pct = ((index + 1) / strategyCards.length) * 100;
          strategyProgressFill.style.width = pct + '%';
        }
      }

      function updateStrategyDots(index) {
        if (!strategyDots || !strategyDots.length) return;
        strategyDots.forEach(function(d, i) {
          d.classList.toggle('active', i === index);
        });
      }

      function updateStrategyArrows(index) {
        if (!strategyPrev || !strategyNext || !strategyCards.length) return;

        var isFirst = index <= 0;
        var isLast = index >= strategyCards.length - 1;

        strategyPrev.classList.toggle('disabled', isFirst);
        strategyPrev.classList.toggle('active', !isFirst);
        strategyPrev.disabled = isFirst;
        strategyPrev.setAttribute('aria-disabled', isFirst ? 'true' : 'false');

        strategyNext.classList.toggle('disabled', isLast);
        strategyNext.classList.toggle('active', !isLast);
        strategyNext.disabled = isLast;
        strategyNext.setAttribute('aria-disabled', isLast ? 'true' : 'false');
      }

      function getStrategyIndexFromScroll() {
        if (!strategyCardsContainer || !strategyCards.length) return 0;

        var scrollLeft = strategyCardsContainer.scrollLeft;
        var maxScroll = strategyCardsContainer.scrollWidth - strategyCardsContainer.clientWidth;
        if (maxScroll > 0 && scrollLeft >= maxScroll - 1) {
          return strategyCards.length - 1;
        }

        var nearestIndex = 0;
        var nearestDistance = Infinity;
        strategyCards.forEach(function(card, index) {
          var distance = Math.abs(card.offsetLeft - scrollLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        return nearestIndex;
      }

      timelineYears.forEach(function(year) {
        year.addEventListener('click', function() {
          var idx = parseInt(this.getAttribute('data-index'), 10);
          scrollToStrategyCard(idx);
        });
      });

      strategyDots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var idx = parseInt(this.getAttribute('data-index'), 10);
          scrollToStrategyCard(idx);
        });
      });

      if (strategyPrev) {
        strategyPrev.addEventListener('click', function() {
          if (currentStrategyIndex > 0) {
            scrollToStrategyCard(currentStrategyIndex - 1);
          }
        });
      }

      if (strategyNext) {
        strategyNext.addEventListener('click', function() {
          if (currentStrategyIndex < strategyCards.length - 1) {
            scrollToStrategyCard(currentStrategyIndex + 1);
          }
        });
      }

      // Sync timeline / progress / dots while the user scrolls the track
      if (strategyCardsContainer) {
        strategyCardsContainer.addEventListener('scroll', function() {
          var scrollLeft = strategyCardsContainer.scrollLeft;
          var maxScroll = strategyCardsContainer.scrollWidth - strategyCardsContainer.clientWidth;
          if (maxScroll > 0) {
            var ratio = scrollLeft / maxScroll;
            var idx = programmaticStrategyIndex !== null ? programmaticStrategyIndex : getStrategyIndexFromScroll();
            if (idx !== currentStrategyIndex) {
              currentStrategyIndex = idx;
              updateStrategyTimeline(idx);
              updateStrategyDots(idx);
              updateStrategyArrows(idx);
            }
            if (strategyProgressFill) {
              strategyProgressFill.style.width = (ratio * 100) + '%';
            }
            if (programmaticStrategyIndex !== null) {
              window.clearTimeout(strategyScrollTimer);
              strategyScrollTimer = window.setTimeout(function() {
                currentStrategyIndex = programmaticStrategyIndex;
                updateStrategyTimeline(currentStrategyIndex);
                updateStrategyProgress(currentStrategyIndex);
                updateStrategyDots(currentStrategyIndex);
                updateStrategyArrows(currentStrategyIndex);
                programmaticStrategyIndex = null;
              }, 120);
            }
          }
        }, { passive: true });
      }

      updateStrategyTimeline(currentStrategyIndex);
      updateStrategyProgress(currentStrategyIndex);
      updateStrategyDots(currentStrategyIndex);
      updateStrategyArrows(currentStrategyIndex);

      // =====================
      // 7. Ecosystem node click to update info panel
      // =====================
      var ecosystemData = {
        governments: {
          title: 'Governments',
          items: [
            'Policymakers shaping national mineral strategy',
            'Driving cross-border policy alignment',
            'Engaging industry and investors to strengthen supply resilience'
          ]
        },
        institutions: {
          title: 'Development Institutions',
          items: [
            'Providing technical assistance and capacity building',
            'Financing sustainable mining projects and infrastructure',
            'Supporting research and data to inform mineral policy'
          ]
        },
        investors: {
          title: 'Investors',
          items: [
            'Channeling capital into sustainable mineral ventures',
            'Identifying high-potential investment opportunities',
            'Driving ESG standards and responsible investment'
          ]
        },
        industry: {
          title: 'Industry',
          items: [
            'Innovating extraction and processing technologies',
            'Building resilient and transparent supply chains',
            'Collaborating on responsible mining standards'
          ]
        }
      };

      var ecosystemNodes = document.querySelectorAll('.eco-node-wrap');
      var ecoInfoTitle = document.getElementById('ecoInfoTitle');
      var ecoInfoList = document.getElementById('ecoInfoList');
      var bulletSrc = '../assets/images/ecosystem-bullet.svg';

      ecosystemNodes.forEach(function(node) {
        node.addEventListener('click', function() {
          var nodeKey = this.getAttribute('data-node');
          var data = ecosystemData[nodeKey];
          if (!data) return;

          // Update active state
          ecosystemNodes.forEach(function(n) { n.classList.remove('active'); });
          this.classList.add('active');

          // Update info panel
          if (ecoInfoTitle) ecoInfoTitle.textContent = data.title;
          if (ecoInfoList) {
            ecoInfoList.innerHTML = data.items.map(function(item) {
              return '<li><img src="' + bulletSrc + '" alt="" class="ecosystem-bullet">' + item + '</li>';
            }).join('');
          }
        });
      });

      // =====================
      // 8. Smooth scroll for anchors
      // =====================
      document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
        anchor.addEventListener('click', function(e) {
          var href = this.getAttribute('href');
          if (href === '#') return;
          var target = document.querySelector(href);
          if (target) {
            e.preventDefault();
           var offset = window.innerWidth < 768 ? 120 : 80;
            var topPos = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: topPos, behavior: 'smooth' });
            
            // Auto-select option in form if data-enquiry-type is provided
            var enquiryType = this.getAttribute('data-enquiry-type');
            if (enquiryType) {
              var selectEl = document.getElementById('enquiryType');
              if (selectEl) {
                selectEl.value = enquiryType;
              }
            }
          }
        });
      });



// =====================
// Forum Background video speed
// =====================


var forumPowerVideo = document.getElementById('forumPowerVideo');
if (forumPowerVideo) {
  forumPowerVideo.playbackRate = 4.0;
}





// =====================
// Cause Number counting animation
// =====================
(function initDiscoverCounters() {
  var discoverSection = document.querySelector('.discover-section');
  if (!discoverSection) return;

  var animated = false;

  function animateDiscoverCounters() {
    
    animated = true;

    discoverSection.querySelectorAll('.discover-stat').forEach(function(stat) {
      var unit = stat.querySelector('.discover-stat-unit');
      var unitText = unit ? unit.outerHTML : '';
      var fullText = stat.textContent.trim();

      // Extract prefix, number, suffix
      var prefix = '';
      var suffix = '';
      var numStr = fullText.replace(unit ? unit.textContent : '', '');

      if (numStr.startsWith('$')) {
        prefix = '$';
        numStr = numStr.slice(1);
      }

      var multiplier = 1;
      if (numStr.endsWith('k')) {
        suffix = 'k';
        numStr = numStr.slice(0, -1);
      } else if (numStr.endsWith('b')) {
        suffix = 'b';
        numStr = numStr.slice(0, -1);
      }

      var target = parseFloat(numStr);
      if (isNaN(target)) return;

      var duration = 2000;
      var startTime = null;

      function easeOutQuart(t) {
        return 1 - Math.pow(1 - t, 4);
      }

      function update(timestamp) {
        if (!startTime) startTime = timestamp;
        var elapsed = timestamp - startTime;
        var progress = Math.min(elapsed / duration, 1);
        var current = Math.floor(easeOutQuart(progress) * target);
        var display = current < 10 && target <= 9 ? '0' + current : current;
stat.innerHTML = prefix + display + suffix + unitText;
        if (progress < 1) {
          requestAnimationFrame(update);
        } else {
          var finalDisplay = target < 10 ? '0' + target : target;
stat.innerHTML = prefix + finalDisplay + suffix + unitText;
        }
      }

      requestAnimationFrame(update);
    });
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        animateDiscoverCounters();
      }
    });
  }, { threshold: 0.3 });

  observer.observe(discoverSection);
})();


// =====================
// CONTACT FORM SUBMISSION FOR FORUM PAGE
// =====================
var contactForm = document.getElementById('contactForm');
var formMessage = document.getElementById('formMessage');

if (contactForm) {
  contactForm.addEventListener('submit', function(e) {
    e.preventDefault();

    var enquiryType = document.getElementById('enquiryType').value;
    var name = document.getElementById('name').value.trim();
    var email = document.getElementById('email').value.trim();

    // Basic validation
    var nameValid = name.length > 0 && /^[a-zA-Z\s'-]+$/.test(name);

    if (!enquiryType || !nameValid || !email) {
      formMessage.style.display = 'block';
      formMessage.style.color = 'red';
      if (!enquiryType) {
        formMessage.textContent = 'Please select an inquiry type.';
      } else if (!nameValid) {
        formMessage.textContent = 'Name should contain letters only, no digits.';
      } else {
        formMessage.textContent = 'Please enter a valid email.';
      }
      return;
    }

    // Success message
    contactForm.reset();
    formMessage.style.display = 'block';
    formMessage.style.color = 'green';
    formMessage.textContent = 'Thank you! Your interest has been registered.';

    setTimeout(function() {
      formMessage.style.display = 'none';
    }, 5000);
  });
}

// =====================
// CONTACT PAGE - GENERAL ENQUIRY FORM
// =====================
(function initGeneralEnquiryForm() {
  var form = document.getElementById('generalEnquiryForm');
  if (!form) return;

  var fullNameInput = document.getElementById('general-full-name');
  var emailInput = document.getElementById('general-email');
  var countryCodeInput = document.getElementById('general-country-code');
  var phoneInput = document.getElementById('general-phone');
  var messageInput = document.getElementById('general-message');
  var termsInput = document.getElementById('terms-general');
  var categoryInput = form.querySelector('[name="enquiryCategory"]');
  var statusMessage = document.getElementById('general-enquiry-status');

  function setFieldError(input, message, errorId, errorTarget) {
    var errorElement = document.getElementById(errorId);
    var target = errorTarget || input;

    target.classList.toggle('is-invalid', Boolean(message));
    input.setAttribute('aria-invalid', message ? 'true' : 'false');

    if (errorElement) {
      errorElement.textContent = message;
    }
  }

  function setStatus(message, type) {
    if (!statusMessage) return;

    statusMessage.textContent = message;
    statusMessage.classList.remove('is-error', 'is-success');

    if (message && type) {
      statusMessage.classList.add(type);
    }
  }

  function validateFullName() {
    var message = fullNameInput.value.trim() ? '' : 'Please enter your full name.';
    setFieldError(fullNameInput, message, 'general-full-name-error');
    return !message;
  }

  function validateEmail() {
    var value = emailInput.value.trim();
    var message = '';

    if (!value) {
      message = 'Please enter your email address.';
    } else if (!emailInput.validity.valid) {
      message = 'Please enter a valid email address.';
    }

    setFieldError(emailInput, message, 'general-email-error');
    return !message;
  }

  function validatePhone() {
    var message = phoneInput.value.trim() ? '' : 'Please enter your phone number.';
    setFieldError(phoneInput, message, 'general-phone-error', phoneInput.closest('.phone-input'));
    return !message;
  }

  function validateTerms() {
    var message = termsInput.checked ? '' : 'You must agree to the Terms & Conditions before submitting.';
    setFieldError(termsInput, message, 'terms-general-error');
    return !message;
  }

  fullNameInput.addEventListener('input', validateFullName);
  emailInput.addEventListener('input', validateEmail);
  phoneInput.addEventListener('input', validatePhone);
  termsInput.addEventListener('change', validateTerms);

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    setStatus('', '');

    var fullNameValid = validateFullName();
    var emailValid = validateEmail();
    var phoneValid = validatePhone();
    var termsValid = validateTerms();
    var categoryValid = Boolean(categoryInput && categoryInput.value);

    if (!fullNameValid || !emailValid || !phoneValid || !termsValid || !categoryValid) {
      setStatus('Please complete all required fields before submitting.', 'is-error');

      var firstInvalidField = form.querySelector('[aria-invalid="true"]');
      if (firstInvalidField) {
        firstInvalidField.focus();
      }
      return;
    }

    var recipient = form.getAttribute('data-recipient') || 'support@fmf.com';
    var phoneNumber = countryCodeInput.value + ' ' + phoneInput.value.trim();
    var subject = categoryInput.value + ' - ' + fullNameInput.value.trim();
    var body = [
      'Enquiry category: ' + categoryInput.value,
      'Full name: ' + fullNameInput.value.trim(),
      'Email: ' + emailInput.value.trim(),
      'Phone: ' + phoneNumber,
      '',
      'Message:',
      messageInput.value.trim() || 'No message provided.'
    ].join('\n');
    var mailtoUrl = 'mailto:' + recipient
      + '?subject=' + encodeURIComponent(subject)
      + '&body=' + encodeURIComponent(body);

    setStatus('Your email application has been opened. Please send the prepared enquiry to complete your submission.', 'is-success');
    window.location.href = mailtoUrl;
  });
})();









      // =====================
      // 9. About page - strategic objectives accordion
      // =====================
      var strategicObjectivesSection = document.querySelector('.so-section'); //was ('.strategic-objectives')
      var strategicAccordionItems = strategicObjectivesSection
        ? strategicObjectivesSection.querySelectorAll('.so-item') //was ('.strategic-objectives-accordion .accordion-item')
        : [];
      var strategicObjectivesImage = document.getElementById('soActiveImage'); //was ('strategicObjectivesImage')
      var strategicActiveIndex = 0;
      var strategicScrollTicking = false;

      function setStrategicAccordionState(index) {
        if (!strategicAccordionItems.length || index < 0 || index >= strategicAccordionItems.length) return;

        strategicActiveIndex = index;

       strategicAccordionItems.forEach(function(item, itemIndex) {
          var isActive = itemIndex === index;
          item.classList.toggle('so-item--active', isActive); // was ('accordion-item-expanded')
          item.classList.toggle('so-item--collapsed', !isActive); // was ('accordion-item-collapsed')
          item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });

        if (strategicObjectivesImage) {
          var activeItem = strategicAccordionItems[index];
          var nextImage = activeItem.getAttribute('data-so-image'); //was (data-image')

          if (nextImage && strategicObjectivesImage.getAttribute('src') !== nextImage) {
            strategicObjectivesImage.classList.add('is-switching');
            window.setTimeout(function() {
              strategicObjectivesImage.setAttribute('src', nextImage);
              strategicObjectivesImage.classList.remove('is-switching');
            }, 120);
          }
        }
      }

      function updateStrategicAccordionFromScroll() {
        if (!strategicObjectivesSection || !strategicAccordionItems.length) return;

        var sectionRect = strategicObjectivesSection.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        var isSectionActive = sectionRect.top < viewportHeight * 0.75 && sectionRect.bottom > viewportHeight * 0.25;

        if (!isSectionActive) return;

        var viewportAnchor = viewportHeight * 0.45;
        var closestIndex = strategicActiveIndex;
        var closestDistance = Number.POSITIVE_INFINITY;

        strategicAccordionItems.forEach(function(item, index) {
          var rect = item.getBoundingClientRect();
          var itemCenter = rect.top + (rect.height / 2);
          var distance = Math.abs(itemCenter - viewportAnchor);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        setStrategicAccordionState(closestIndex);
      }

      if (strategicAccordionItems.length > 0) {
        setStrategicAccordionState(0);

        strategicAccordionItems.forEach(function(item, index) {
          item.addEventListener('click', function() {
            setStrategicAccordionState(index);
            this.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });

          item.addEventListener('keydown', function(event) {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              setStrategicAccordionState(index);
              this.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          });
        });

        window.addEventListener('scroll', function() {
          if (strategicScrollTicking) return;
          strategicScrollTicking = true;

          window.requestAnimationFrame(function() {
            updateStrategicAccordionFromScroll();
            strategicScrollTicking = false;
          });
        }, { passive: true });

        window.addEventListener('resize', updateStrategicAccordionFromScroll);
        updateStrategicAccordionFromScroll();
      }
      
   
      // =====================
      // 10. Knowledge Hub — video player + thumb carousel
      // =====================
      (function initKnowledgeHub() {
        var knowledgePlayer = document.getElementById('knowledgePlayer');
        var playerVideo = document.getElementById('knowledgePlayerVideo');
        var playBtn = document.getElementById('playerPlayBtn');
        var bigPlay = document.getElementById('playerBigPlay');
        var muteBtn = document.getElementById('playerMuteBtn');
        var fullscreenBtn = document.getElementById('playerFullscreenBtn');
        var progressBar = document.getElementById('playerProgressBar');
        var progressFill = document.getElementById('playerProgressFill');
        var timeLabel = document.getElementById('playerTime');
        var thumbsContainer = document.getElementById('knowledgeThumbs');
        var thumbNavLeft = document.querySelector('.home-knowledge .thumb-nav-left');
        var thumbNavRight = document.querySelector('.home-knowledge .thumb-nav-right');
        var thumbCards = document.querySelectorAll('.home-knowledge .thumb-card');
        var knowledgeTabs = document.querySelectorAll('.home-knowledge .knowledge-tab');
        var knowledgePanels = document.querySelectorAll('.home-knowledge .knowledge-tab-panel');
        var isKnowledgeHubLibraryPage = /\/knowledge-hub\/library\/?$/.test(window.location.pathname) ||
          /\/knowledge-hub-library\.html$/.test(window.location.pathname);

        // ---- Tab switching ----
        knowledgeTabs.forEach(function(tab) {
          tab.addEventListener('click', function() {
            var selectedTab = tab.getAttribute('data-tab');

            knowledgeTabs.forEach(function(t) {
              t.classList.remove('active');
              t.setAttribute('aria-selected', 'false');
            });

            knowledgePanels.forEach(function(panel) {
              var isActive = panel.getAttribute('data-tab-panel') === selectedTab;
              panel.classList.toggle('active', isActive);
              panel.hidden = !isActive;
            });

            tab.classList.add('active');
            tab.setAttribute('aria-selected', 'true');

            if (isKnowledgeHubLibraryPage && selectedTab) {
              history.replaceState(null, null, window.location.pathname + '#' + selectedTab);
            }

            if (selectedTab !== 'fmf-tv' && typeof playerVideo !== 'undefined' && playerVideo && !playerVideo.paused) {
              playerVideo.pause();
            }
          });
        });
        // ---- Handle URL Hash for direct tab linking ----
        var hash = window.location.hash;
        if (hash) {
          var targetTabId = hash.replace('#', '');
          var targetTab = document.querySelector('.home-knowledge .knowledge-tab[data-tab="' + targetTabId + '"]');
          if (targetTab) {
            // Wait a brief moment for layout, then click and scroll
            setTimeout(function() {
              targetTab.click();
              var section = document.querySelector('.engagements-library-knowledge-hub');
              if (section) {
                var offsetTop = section.getBoundingClientRect().top + window.pageYOffset - 100;
                window.scrollTo({ top: offsetTop, behavior: 'smooth' });
              }
              if (!isKnowledgeHubLibraryPage) {
                history.replaceState(null, null, window.location.pathname);
              }
            }, 100);
          }
        }

        if (!knowledgePlayer || !playerVideo) return;
        function formatTime(seconds) {
          if (!isFinite(seconds) || seconds < 0) return '0:00';
          var m = Math.floor(seconds / 60);
          var s = Math.floor(seconds % 60);
          return m + ':' + (s < 10 ? '0' + s : s);
        }

        function updateTimeLabel() {
          if (!timeLabel) return;
          timeLabel.textContent =
            formatTime(playerVideo.currentTime) + ' / ' + formatTime(playerVideo.duration || 0);
        }

        function updateProgressFill() {
          if (!progressFill || !playerVideo.duration) return;
          var pct = (playerVideo.currentTime / playerVideo.duration) * 100;
          progressFill.style.width = pct + '%';
        }

        function playVideo() {
          var p = playerVideo.play();
          if (p && typeof p.catch === 'function') {
            p.catch(function() { /* autoplay blocked — ignore */ });
          }
        }

        playerVideo.addEventListener('play', function() {
          knowledgePlayer.setAttribute('data-state', 'playing');
          if (playBtn) playBtn.setAttribute('aria-label', 'Pause');
        });
        playerVideo.addEventListener('pause', function() {
          knowledgePlayer.setAttribute('data-state', 'paused');
          if (playBtn) playBtn.setAttribute('aria-label', 'Play');
        });
        playerVideo.addEventListener('timeupdate', function() {
          updateProgressFill();
          updateTimeLabel();
        });
        playerVideo.addEventListener('loadedmetadata', function() {
          updateTimeLabel();
          updateProgressFill();
        });
        playerVideo.addEventListener('ended', function() {
          knowledgePlayer.setAttribute('data-state', 'paused');
        });

        if (playBtn) {
          playBtn.addEventListener('click', function() {
            if (playerVideo.paused) playVideo(); else playerVideo.pause();
          });
        }
        if (bigPlay) {
          bigPlay.addEventListener('click', function() {
            if (playerVideo.paused) playVideo(); else playerVideo.pause();
          });
        }

        // Click on video itself toggles play/pause
        playerVideo.addEventListener('click', function() {
          if (playerVideo.paused) playVideo(); else playerVideo.pause();
        });

        if (muteBtn) {
          muteBtn.addEventListener('click', function() {
            playerVideo.muted = !playerVideo.muted;
            knowledgePlayer.classList.toggle('is-muted', playerVideo.muted);
            muteBtn.setAttribute('aria-label', playerVideo.muted ? 'Unmute' : 'Mute');
          });
        }

        if (fullscreenBtn) {
          fullscreenBtn.addEventListener('click', function() {
            if (document.fullscreenElement) {
              document.exitFullscreen();
            } else if (knowledgePlayer.requestFullscreen) {
              knowledgePlayer.requestFullscreen();
            } else if (playerVideo.webkitEnterFullscreen) {
              playerVideo.webkitEnterFullscreen();
            }
          });
        }

        // Click on progress bar to seek
        function seekFromEvent(e) {
          if (!playerVideo.duration) return;
          var rect = progressBar.getBoundingClientRect();
          var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
          var ratio = Math.min(1, Math.max(0, x / rect.width));
          playerVideo.currentTime = ratio * playerVideo.duration;
          updateProgressFill();
        }
        if (progressBar) {
          progressBar.addEventListener('click', seekFromEvent);
        }

        // ---- Thumb videos: hover autoplay muted + real duration ----
        thumbCards.forEach(function(card) {
          var video = card.querySelector('.thumb-video');
          var durationEl = card.querySelector('[data-duration]');

          if (video) {
            // Populate duration from metadata
            function setDuration() {
              if (durationEl && isFinite(video.duration)) {
                durationEl.textContent = formatTime(video.duration);
              }
            }
            if (video.readyState >= 1) {
              setDuration();
            } else {
              video.addEventListener('loadedmetadata', setDuration, { once: true });
            }

            if (video) {
              video.addEventListener('canplay', function () {
                setTimeout(() => {
                  video.currentTime = 8;

                  video.play().then(() => {
                    video.pause();
                  }).catch(() => {});
                }, 100);
              }, { once: true });
            }

            // Hover autoplay (muted), leave pauses and rewinds
            card.addEventListener('mouseenter', function() {
              video.currentTime = 8;
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function() {});
            });
            card.addEventListener('mouseleave', function() {
              video.pause();
              video.currentTime = 8;
            });
          }

          // Click to load into main player
          card.addEventListener('click', function() {
            thumbCards.forEach(function(c) { c.classList.remove('active'); });
            card.classList.add('active');
            var url = card.getAttribute('data-video-url');
            if (url && playerVideo) {
              playerVideo.src = url;
              playerVideo.load();
              playVideo();
            }
          });
        });



        // ---- Thumb carousel nav arrows + drag scroll ----
        if (thumbsContainer) {
          var scrollStep = 250;
          if (thumbNavLeft) {
            thumbNavLeft.addEventListener('click', function() {
              thumbsContainer.scrollTo({
                left: thumbsContainer.scrollLeft - scrollStep,
                behavior: 'smooth'
              });
            });
          }
          if (thumbNavRight) {
            thumbNavRight.addEventListener('click', function() {
              thumbsContainer.scrollTo({
                left: thumbsContainer.scrollLeft + scrollStep,
                behavior: 'smooth'
              });
            });
          }

          var isDown = false;
          var startX;
          var scrollLeftStart;
          thumbsContainer.addEventListener('mousedown', function(e) {
            isDown = true;
            startX = e.pageX - thumbsContainer.offsetLeft;
            scrollLeftStart = thumbsContainer.scrollLeft;
          });
          thumbsContainer.addEventListener('mouseleave', function() { isDown = false; });
          thumbsContainer.addEventListener('mouseup', function() { isDown = false; });
          thumbsContainer.addEventListener('mousemove', function(e) {
            if (!isDown) return;
            e.preventDefault();
            var x = e.pageX - thumbsContainer.offsetLeft;
            thumbsContainer.scrollLeft = scrollLeftStart - (x - startX) * 1.5;
          });
        }
      })();

      // =====================
      // 11. Initiatives pillar tab states
      // =====================
      var pillarTabs = document.querySelectorAll('.pillar-tab');

      if (pillarTabs.length > 0) {
        pillarTabs.forEach(function(tab) {
          tab.addEventListener('click', function() {
            pillarTabs.forEach(function(tabItem) {
              tabItem.classList.remove('active');
              tabItem.setAttribute('aria-pressed', 'false');
            });

            this.classList.add('active');
            this.setAttribute('aria-pressed', 'true');
          });
          
          // Update URL hash when a tab is shown
          tab.addEventListener('shown.bs.tab', function(e) {
            var targetId = e.target.getAttribute('data-bs-target');
            if (targetId) {
              var cleanHash = targetId.replace('-tab', '');
              history.replaceState(null, null, cleanHash);
            }
          });
        });

        // Open specific tab on load based on URL hash
        var hash = window.location.hash;
        if (hash) {
          var targetTab = document.querySelector('.pillar-tab[data-bs-target="' + hash + '-tab"]');
          if (targetTab) {
            targetTab.click();
          }
        }
      }

      /* Legacy Knowledge Hub arrow/drag/play-button handlers were moved
         into the initKnowledgeHub IIFE above (section 10). */




// Active nav link based on current page
const currentPath = window.location.pathname;
document.querySelectorAll('.nav-links li a').forEach(function(link) {
  const href = link.getAttribute('href');
  if (!href || href === '#') return;
  
  try {
    const linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
    const cleanCurrentPath = currentPath.replace(/\/$/, '');
    
    if (cleanCurrentPath === linkPath || cleanCurrentPath.startsWith(linkPath + '/')) {
      link.classList.add('active');
    }
  } catch(e) {}
});








      // =====================
      // 11b. Barometer carousel — Slick fade + custom arrows
      // =====================
      var barometerSlider = $('#barometerSlider');
      var barometerArrowPrev = $('.barometer-arrow-prev');
      var barometerArrowNext = $('.barometer-arrow-next');

      if (barometerSlider.length > 0 && typeof barometerSlider.slick === 'function') {
        barometerSlider.slick({
          infinite: false,               /* disabled infinite loop */
          speed: 600,
          fade: true, 
          cssEase: 'cubic-bezier(0.22, 1, 0.36, 1)',
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          prevArrow: barometerArrowPrev,
          nextArrow: barometerArrowNext,
          dots: false,
          adaptiveHeight: false, /* was true */
          autoplay: false,               /* disabled autoplay as infinite loop is stopped */
          autoplaySpeed: 5000,           /* 5s per slide */
          pauseOnHover: true,
          pauseOnFocus: true,
          lazyLoad: 'ondemand'/*added */
        });

        function updateBarometerArrowStates() {
          var currentSlide = barometerSlider.slick('slickCurrentSlide');
          var totalSlides = barometerSlider.slick('getSlick').slideCount;

          if (currentSlide === 0) {
            barometerArrowPrev.addClass('is-disabled').removeClass('is-active');
            barometerArrowPrev.attr('disabled', 'disabled');
          } else {
            barometerArrowPrev.removeClass('is-disabled').addClass('is-active');
            barometerArrowPrev.removeAttr('disabled');
          }

          if (currentSlide >= totalSlides - 1) {
            barometerArrowNext.addClass('is-disabled').removeClass('is-active');
            barometerArrowNext.attr('disabled', 'disabled');
          } else {
            barometerArrowNext.removeClass('is-disabled').addClass('is-active');
            barometerArrowNext.removeAttr('disabled');
          }
        }

        updateBarometerArrowStates();

        barometerSlider.on('afterChange', function() {
          updateBarometerArrowStates();
        });
      }






      // =====================
      // 12. Channels carousel with Slick
      // =====================
      var channelsGrid = $('.channels-grid');
      var channelsArrowBtns = document.querySelectorAll('.channels-arrow-btn');
      var channelsProgressFill = document.querySelector('.channels-progress-fill');

      if (channelsGrid.length > 0) {
        channelsGrid.slick({
          infinite: false,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });

        // Connect custom arrow buttons to Slick
        if (channelsArrowBtns.length >= 2) {
          var prevBtn = channelsArrowBtns[0];
          var nextBtn = channelsArrowBtns[1];

          prevBtn.addEventListener('click', function(e) {
            if (!this.classList.contains('is-disabled')) {
              channelsGrid.slick('slickPrev');
              updateChannelsProgress();
              updateArrowStates();
            }
            e.preventDefault();
          });

          nextBtn.addEventListener('click', function(e) {
            if (!this.classList.contains('is-disabled')) {
              channelsGrid.slick('slickNext');
              updateChannelsProgress();
              updateArrowStates();
            }
            e.preventDefault();
          });
        }

        // Update arrow states based on slider position
        function updateArrowStates() {
          var currentSlide = channelsGrid.slick('slickCurrentSlide');
          var totalSlides = channelsGrid.slick('getSlick').slideCount;
          var slidesToShow = channelsGrid.slick('getSlick').options.slidesToShow;
          var maxIndex = Math.max(0, totalSlides - slidesToShow);

          if (channelsArrowBtns.length >= 2) {
            var prevBtn = channelsArrowBtns[0];
            var nextBtn = channelsArrowBtns[1];

            // Update previous button
            if (currentSlide === 0) {
              prevBtn.classList.add('is-disabled');
              prevBtn.classList.remove('is-active');
            } else {
              prevBtn.classList.remove('is-disabled');
              prevBtn.classList.add('is-active');
            }

            // Update next button
            if (currentSlide >= maxIndex) {
              nextBtn.classList.add('is-disabled');
              nextBtn.classList.remove('is-active');
            } else {
              nextBtn.classList.remove('is-disabled');
              nextBtn.classList.add('is-active');
            }
          }
        }

        // Update progress bar
        function updateChannelsProgress() {
          var currentSlide = channelsGrid.slick('slickCurrentSlide');
          var totalSlides = channelsGrid.slick('getSlick').slideCount;
          var slidesToShow = channelsGrid.slick('getSlick').options.slidesToShow;
          var maxIndex = Math.max(0, totalSlides - slidesToShow);
          
         if (channelsProgressFill) {
  
    //ADDED THIS==
    var minPct = (1 / totalSlides) * 100;           // e.g. 25% for 4 cards
    var progress = maxIndex > 0
      ? minPct + (currentSlide / maxIndex) * (100 - minPct)
      : 100;
    channelsProgressFill.style.width = progress + '%';
  }
  //==============
        }

        // Initialize arrow states and progress
        updateArrowStates();
        updateChannelsProgress();

        // Update on slide change
        channelsGrid.on('afterChange', function() {
          updateArrowStates();
          updateChannelsProgress();
        });

        // Handle window resize for responsive changes
        window.addEventListener('resize', function() {
          setTimeout(function() {
            updateArrowStates();
            updateChannelsProgress();
          }, 100);
        });
      }

      // =====================
      // 12b. Media carousel with Slick
      // =====================
      var mediaSlider = $('.media-slider');
      var mediaArrowBtns = document.querySelectorAll('.media-arrow-btn');
      var mediaProgressFill = document.querySelector('.media-progress-fill');

      if (mediaSlider.length > 0) {
        mediaSlider.slick({
          infinite: false,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          adaptiveHeight: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });

        function updateMediaArrowStates() {
          var currentSlide = mediaSlider.slick('slickCurrentSlide');
          var totalSlides = mediaSlider.slick('getSlick').slideCount;
          var slidesToShow = mediaSlider.slick('getSlick').options.slidesToShow;
          var maxIndex = Math.max(0, totalSlides - slidesToShow);

          if (mediaArrowBtns.length >= 2) {
            var prevMediaBtn = mediaArrowBtns[0];
            var nextMediaBtn = mediaArrowBtns[1];

            if (currentSlide === 0) {
              prevMediaBtn.classList.add('is-disabled');
              prevMediaBtn.classList.remove('is-active');
            } else {
              prevMediaBtn.classList.remove('is-disabled');
              prevMediaBtn.classList.add('is-active');
            }

            if (currentSlide >= maxIndex) {
              nextMediaBtn.classList.add('is-disabled');
              nextMediaBtn.classList.remove('is-active');
            } else {
              nextMediaBtn.classList.remove('is-disabled');
              nextMediaBtn.classList.add('is-active');
            }
          }
        }

        function updateMediaProgress() {
          var currentSlide = mediaSlider.slick('slickCurrentSlide');
          var totalSlides = mediaSlider.slick('getSlick').slideCount;
          var slidesToShow = mediaSlider.slick('getSlick').options.slidesToShow;

          if (mediaProgressFill) {
            var minPct = (1 / totalSlides) * 100;
            var maxIndex = Math.max(0, totalSlides - slidesToShow);
            var progress = maxIndex > 0
              ? minPct + (currentSlide / maxIndex) * (100 - minPct)
              : 100;
            mediaProgressFill.style.width = progress + '%';
          }
        }

        if (mediaArrowBtns.length >= 2) {
          var mediaPrevBtn = mediaArrowBtns[0];
          var mediaNextBtn = mediaArrowBtns[1];

          mediaPrevBtn.addEventListener('click', function(e) {
            if (!this.classList.contains('is-disabled')) {
              mediaSlider.slick('slickPrev');
            }
            e.preventDefault();
          });

          mediaNextBtn.addEventListener('click', function(e) {
            if (!this.classList.contains('is-disabled')) {
              mediaSlider.slick('slickNext');
            }
            e.preventDefault();
          });
        }

        updateMediaArrowStates();
        updateMediaProgress();

        mediaSlider.on('afterChange', function() {
          updateMediaArrowStates();
          updateMediaProgress();
        });

        window.addEventListener('resize', function() {
          setTimeout(function() {
            updateMediaArrowStates();
            updateMediaProgress();
          }, 100);
        });
      }

      // Footer blob scroll animation
      const footerBlob = document.querySelector('.footer-blob');
      if (footerBlob) {
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              footerBlob.classList.add('is-visible');
              observer.disconnect(); // fire once
            }
          },
          { threshold: 0.1 }
        );
        observer.observe(footerBlob.closest('.footer-blob-wrap'));
      }

      // =====================
      // 1. Intersection Observer for scroll animations
      // =====================
      var scrollElements1 = document.querySelectorAll('.animate-on-scroll');
      var scrollObserver1 = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      }, { threshold: 0.15 });

      scrollElements1.forEach(function(el) {
        scrollObserver1.observe(el);
      });


      // Engagement carousel
      var engagementTrack = document.getElementById('engagementTrack');
      var engagementFill = document.getElementById('engagementFill');
      var engagementPrevBtn = document.getElementById('engagementPrev');
      var engagementNextBtn = document.getElementById('engagementNext');

      function updateEngagementProgress() {
        if (!engagementTrack) return;
        
        var scrollLeft = engagementTrack.scrollLeft;
        var maxScroll = engagementTrack.scrollWidth - engagementTrack.clientWidth;
        
        if (engagementFill) {
          var progress = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 0;
          engagementFill.style.width = Math.max(10, progress) + '%';
        }

        if (engagementPrevBtn) {
          if (scrollLeft > 10) {
            engagementPrevBtn.classList.add('enabled', 'active');
            engagementPrevBtn.classList.remove('disabled');
            engagementPrevBtn.removeAttribute('disabled');
          } else {
            engagementPrevBtn.classList.remove('enabled', 'active');
            engagementPrevBtn.classList.add('disabled');
            engagementPrevBtn.setAttribute('disabled', 'true');
          }
        }
        if (engagementNextBtn) {
          if (maxScroll <= 0 || scrollLeft >= maxScroll - 10) {
            engagementNextBtn.classList.remove('enabled', 'active');
            engagementNextBtn.classList.add('disabled');
            engagementNextBtn.setAttribute('disabled', 'true');
          } else {
            engagementNextBtn.classList.add('enabled', 'active');
            engagementNextBtn.classList.remove('disabled');
            engagementNextBtn.removeAttribute('disabled');
          }
        }
      }

      if (engagementTrack) {
        engagementTrack.addEventListener('scroll', updateEngagementProgress);
        // Call initially and on resize to set default navigation arrow state
        window.addEventListener('load', updateEngagementProgress);
        window.addEventListener('resize', updateEngagementProgress);
        setTimeout(updateEngagementProgress, 300); //was 100
        
        // Recalculate when the engagement tab becomes visible
        var engagementTabBtn = document.querySelector('button[data-bs-target="#engagement-tab"]');
        if (engagementTabBtn) {
          engagementTabBtn.addEventListener('shown.bs.tab', function() {
            // small delay to ensure display: block is fully rendered
            setTimeout(updateEngagementProgress, 50);
          });
        }
      }

      if (engagementPrevBtn) {
        engagementPrevBtn.addEventListener('click', function() {
          engagementTrack.scrollBy({ left: -340, behavior: 'smooth' });
        });
      }

      if (engagementNextBtn) {
        engagementNextBtn.addEventListener('click', function() {
          engagementTrack.scrollBy({ left: 340, behavior: 'smooth' });
        });
      }


      // Intersection Observer for scroll animations
      var scrollElementsBm = document.querySelectorAll('.animate-on-scroll');
      var scrollObserverBm = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

      scrollElementsBm.forEach(function(el) {
        scrollObserverBm.observe(el);
      });

      // Nav shadow on scroll
      var mainNav = document.getElementById('mainNav');
      window.addEventListener('scroll', function() {
        if (mainNav) {
          if (window.scrollY > 10) {
            mainNav.classList.add('scrolled');
          } else {
            mainNav.classList.remove('scrolled');
          }
        }
      }, { passive: true });

      // Diamond diagram interaction
      var reportSection = document.querySelector('.report-section');

      if (reportSection) {
        var diamondItems = reportSection.querySelectorAll('.report-diagram .diamond-item');
        var diamondTitle = reportSection.querySelector('#diamondTitle');
        var diamondDesc = reportSection.querySelector('#diamondDesc');
        var accordionItems = reportSection.querySelectorAll('.report-accordion-item');
        var accordionTriggers = reportSection.querySelectorAll('.report-accordion-trigger');

        function setReportContent(title, desc) {
          if (diamondTitle && diamondDesc) {
            diamondTitle.innerHTML = title;
            diamondDesc.textContent = desc;
          }
        }

        function setActiveDiamond(activeItem) {
          if (!activeItem) return;

          diamondItems.forEach(function(item) {
            var isActive = item === activeItem;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-pressed', isActive ? 'true' : 'false');

            var shape = item.querySelector('.diamond-shape');
            if (shape) {
              shape.classList.toggle('active', isActive);
            }
          });

          setReportContent(activeItem.getAttribute('data-title'), activeItem.getAttribute('data-desc'));
        }

        function setActiveAccordion(activeTrigger) {
          if (!activeTrigger) return;

          accordionItems.forEach(function(item) {
            var trigger = item.querySelector('.report-accordion-trigger');
            var panel = item.querySelector('.report-accordion-panel');
            var icon = item.querySelector('.report-accordion-icon');
            var isActive = trigger === activeTrigger;

            item.classList.toggle('is-open', isActive);
            trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');

            if (panel) {
              panel.hidden = !isActive;
            }

            if (icon) {
              icon.classList.toggle('is-active', isActive);
            }
          });
        }

        diamondItems.forEach(function(item) {
          item.addEventListener('click', function() {
            setActiveDiamond(item);
          });
        });

        accordionTriggers.forEach(function(trigger) {
          trigger.addEventListener('click', function() {
            setActiveAccordion(trigger);
          });
        });

        var initialDiamond = reportSection.querySelector('.report-diagram .diamond-item.is-active') || diamondItems[0];
        var initialAccordion = reportSection.querySelector('.report-accordion-item.is-open .report-accordion-trigger') || accordionTriggers[0];

        setActiveDiamond(initialDiamond);
        setActiveAccordion(initialAccordion);
      }

      // Leaders carousel
      var leadersTrack = $('#leadersTrack');
      var leadersFill = document.getElementById('leadersFill');
      var leadersPrevBtn = document.getElementById('leadersPrev');
      var leadersNextBtn = document.getElementById('leadersNext');

      if (leadersTrack.length > 0 && typeof leadersTrack.slick === 'function') {
        leadersTrack.slick({
          infinite: false,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          adaptiveHeight: false,
          touchThreshold: 12,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true
              }
            }
          ]
        });

        function updateLeadersArrowStates() {
          if (!leadersPrevBtn || !leadersNextBtn) return;

          var currentSlide = leadersTrack.slick('slickCurrentSlide');
          var slickInstance = leadersTrack.slick('getSlick');
          var totalSlides = slickInstance.slideCount;
          var slidesToShow = slickInstance.options.slidesToShow;
          var maxIndex = Math.max(0, totalSlides - slidesToShow);

          if (currentSlide === 0) {
            leadersPrevBtn.classList.remove('enabled');
          } else {
            leadersPrevBtn.classList.add('enabled');
          }

          if (currentSlide >= maxIndex) {
            leadersNextBtn.classList.remove('enabled');
          } else {
            leadersNextBtn.classList.add('enabled');
          }
        }

        function updateLeadersProgress() {
          if (!leadersFill) return;

          var currentSlide = leadersTrack.slick('slickCurrentSlide');
          var slickInstance = leadersTrack.slick('getSlick');
          var totalSlides = slickInstance.slideCount;
          var slidesToShow = slickInstance.options.slidesToShow;
          var maxIndex = Math.max(0, totalSlides - slidesToShow);
          var minPct = totalSlides > 0 ? (slidesToShow / totalSlides) * 100 : 100;
          var progress = maxIndex > 0
            ? minPct + (currentSlide / maxIndex) * (100 - minPct)
            : 100;

          leadersFill.style.width = progress + '%';
        }

        if (leadersPrevBtn) {
          leadersPrevBtn.addEventListener('click', function(e) {
            if (!this.classList.contains('enabled')) {
              e.preventDefault();
              return;
            }

            leadersTrack.slick('slickPrev');
            e.preventDefault();
          });
        }

        if (leadersNextBtn) {
          leadersNextBtn.addEventListener('click', function(e) {
            if (!this.classList.contains('enabled')) {
              e.preventDefault();
              return;
            }

            leadersTrack.slick('slickNext');
            e.preventDefault();
          });
        }

        updateLeadersArrowStates();
        updateLeadersProgress();

        leadersTrack.on('afterChange setPosition breakpoint', function() {
          updateLeadersArrowStates();
          updateLeadersProgress();
        });

        window.addEventListener('resize', function() {
          setTimeout(function() {
            updateLeadersArrowStates();
            updateLeadersProgress();
          }, 50);
        });
      }
      
//==========ADDED==========

      // Auto-scroll pillar tabs when clicked
document.querySelectorAll('.pillar-tab').forEach(function(tab) {
  tab.addEventListener('click', function() {
    var tabList = document.querySelector('.pillar-tabs');
    if (!tabList) return;

    var tabRect = tab.getBoundingClientRect();
    var listRect = tabList.getBoundingClientRect();

    var scrollTo = tabList.scrollLeft + (tabRect.left - listRect.left) - (listRect.width / 2) + (tabRect.width / 2);

    tabList.scrollTo({
      left: scrollTo,
      behavior: 'smooth'
    });
  });
});

      (function initForumVisibilitySection() {
        var section = document.querySelector('.forum-visibility-section');
        if (!section) return;

        var tabs = section.querySelectorAll('.forum-visibility-tab');
        var panels = section.querySelectorAll('.forum-visibility-panel');
        var accordionItems = section.querySelectorAll('.forum-visibility-accordion-item');
        var accordionTriggers = section.querySelectorAll('.forum-visibility-accordion-trigger');

        function animatePanel(panel) {
          if (!panel) return;
          panel.classList.remove('is-animate');
          window.requestAnimationFrame(function() {
            panel.classList.add('is-animate');
          });
        }

        function activateDesktopPanel(target) {
          tabs.forEach(function(tab) {
            var isActive = tab.getAttribute('data-target') === target;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });

          panels.forEach(function(panel) {
            var isActive = panel.getAttribute('data-panel') === target;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
            if (!isActive) panel.classList.remove('is-animate');
          });

          animatePanel(section.querySelector('.forum-visibility-panel[data-panel="' + target + '"]'));
        }

        tabs.forEach(function(tab) {
          tab.addEventListener('click', function() {
            activateDesktopPanel(tab.getAttribute('data-target'));
          });
        });

        function closeAccordionItem(item) {
          var trigger = item.querySelector('.forum-visibility-accordion-trigger');
          var panel = item.querySelector('.forum-visibility-accordion-panel');
          item.classList.remove('is-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          if (panel) {
            panel.hidden = true;
            panel.classList.remove('is-animate');
          }
        }

        function openAccordionItem(item) {
          var trigger = item.querySelector('.forum-visibility-accordion-trigger');
          var panel = item.querySelector('.forum-visibility-accordion-panel');
          item.classList.add('is-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'true');
          if (panel) {
            panel.hidden = false;
            animatePanel(panel);
          }
        }

        accordionTriggers.forEach(function(trigger) {
          trigger.addEventListener('click', function() {
            var item = trigger.closest('.forum-visibility-accordion-item');
            var isOpen = item && item.classList.contains('is-open');
            accordionItems.forEach(closeAccordionItem);
            if (!isOpen && item) {
              openAccordionItem(item);
            }
          });
        });

        var initialDesktop = section.querySelector('.forum-visibility-tab.is-active');
        if (initialDesktop) {
          activateDesktopPanel(initialDesktop.getAttribute('data-target'));
        }

        var initialAccordion = section.querySelector('.forum-visibility-accordion-item.is-open');
        if (initialAccordion) {
          openAccordionItem(initialAccordion);
        }
      })();

      // =====================
      // Horizontal Scroll for Contact Tabs on Mobile
      // =====================
      (function initContactTabsScroll() {
        var contactTabs = document.querySelector('.contact-tabs');
        if (!contactTabs) return;

        var tabBtns = contactTabs.querySelectorAll('.tab-btn');
        tabBtns.forEach(function(btn) {
          btn.addEventListener('click', function() {
            if (window.innerWidth < 768) {
              var containerLeft = contactTabs.getBoundingClientRect().left;
              var btnLeft = btn.getBoundingClientRect().left;
              var btnWidth = btn.offsetWidth;
              var containerWidth = contactTabs.offsetWidth;
              
              var scrollOffset = btnLeft - containerLeft - (containerWidth / 2) + (btnWidth / 2);
              
              contactTabs.scrollBy({
                left: scrollOffset,
                behavior: 'smooth'
              });
            }
          });
        });
      })();

    })();
